<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :value="value"
                :options="directionOptions"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'flex-direction',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Content Direction',
            tailwindDefinitionProp: 'flexDirection',
            value: '',

            directionOptions: [
                { text: 'Column', value: 'col' },
                { text: 'Row', value: 'row' },
                { text: 'Reversed Column', value: 'col-reverse' },
                { text: 'Reversed Row', value: 'row-reverse' },
            ],
        };
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;

            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.value = this.flexClassDefinition.value;
        },
    },
};
</script>
